import script from "./ProductDetailPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetailPrice.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__